<template>
  <div>
    <div class="table_head">
    <span>费用单明细</span>
    <el-button type="primary" icon="el-icon-plus" size="mini" circle @click="addGoods" v-if="!readonly" style="float:right;margin:10px 15px 10px 0;"></el-button>
    </div>
    <el-table border :data="tableData" style="width: 100%">
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="DocNo" label="单据编号" min-width="150px" show-overflow-tooltip />
        <el-table-column prop="DocDate" label="单据日期" min-width="110px">
          <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
        </el-table-column>
        <el-table-column prop="TradeUnitName" label="单位名称" min-width="130px" show-overflow-tooltip />
         <el-table-column prop="ClerkName" label="经办人" />
      <el-table-column label="操作" align="center" width="130px" v-if="!readonly">
        <template slot-scope="scope">
          <el-link icon="el-icon-copy-document" style="margin-right:10px;" @click="copy(scope.row,scope.$index)" :underline="false">复制</el-link>
          <el-link icon="el-icon-delete" @click="del(scope.row,scope.$index)" :underline="false">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-divider></el-divider>
    <goods-dialog ref="goodsDialog" in-dialog selectable @select="setGoods" />
    <customer-dialog ref="customerDialog" in-dialog selectable @select="setCost" title="费用单" />
  </div>
</template>
<script>
import customerDialog from "@/components/purchase/business/splitbill/listDialog";
import goodsDialog from "@/components/sales/business/listDialog";
export default {
  props: {
    info: {},
    readonly: {
      type: Boolean,
      default: false,
    },
    disposeTax: {
      type: String,
      default: "",
    }
  },
  components: {
    goodsDialog,
    customerDialog
  },
  data() {
    return {
      tableData: [],
      tableDel: [],
      sApi: require("@/api/goods/goods").default,
      api: require("@/api/sale/stInDoc").default,
      saleApi: require("@/api/purchase/stock").default,
      PriAdjustGoodsList: [],
    };
  },
  methods: {
    getData() {
      this.tableData = []
      this.saleApi.getGoodsList(this.info.OrderId).then((res) => {
        this.tableData = res.Data;
      });
    },
    del(row,index) {
      this.$confirm("确认删除该行数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if(row.T!==0) {
            row.T = 2
            this.tableDel.push(row)
          }
          this.tableData.splice(index,1)
          this.subTable()
        })
    },
    copy(row,index) {
        this.tableData.splice(index,0,{
          ...row
        })
        this.tableData[index].OrderGoodsId = 0
        this.tableData[index].T = 0
        this.subTable()
    },
    addGoods() {
      let ids = this.PriAdjustGoodsList.map((x) => x.GoodsId);
      // this.$refs.goodsDialog.open().then((that) => {
      //   that.getData({ Status: 1, NotIds: ids });
      // });
       this.$refs.customerDialog.open().then((that) => {
        that.getData();
      });
      
    },
    setCost(e){
       this.tableData.push(e)
    },
    setGoods(e) {
      let date = new Date()
      let today = date.getFullYear()+"-" + (date.getMonth()+1) + "-" + date.getDate();
      this.sApi.getGoodsPrice({ GoodsIds: [e.GoodsId], AdjustDate: this.info.DocDate }).then(res => {
        let goods = {
          T: 0,
          OrderGoodsId: 0,
          OrderId: this.info.OrderId || 0,
          BarCode: e.BarCode,
          GoodsName: e.GoodsName,
          GoodsId: e.GoodsId,
          Model: e.Model || "",
          UnitId: e.UnitId || 0,
          UnitName: e.MainUnitName || "",
          Quantity: 0,
          BatchNo: e.BatchNo || "",
          Offer:  e.WholesalePrice || 0,
          Discount: 100,
          Price: e.WholesalePrice || 0,
          NoTaxPrice:e.WholesalePrice || 0,
          ExistQuantity: e.ExistQuantity || 0,
          AvailableQuantity: e.AvailableQuantity || 0,
          TaxRate: 0,
          TaxAmount: 0,
          Amount: 0,
          NoTaxAmount: 0,
          PromotionType: 0,
          PromotionId: 0,
          ReferenceCost: e.ReferenceCost || 0,
          GrossProfit: 0,
          Remark: e.Remark || "",
          Thumbnail: "",
          OutQuantity: 0,
          AddTime: this.info.DocDate || today
        }
        if(res.Data != null) {
          goods.Offer = res.Data.VirtualPrice
        }
        this.tableData.push(goods)
      })
    },
    changeNum(row) {
      // row.Quantity = Math.floor(row.Quantity)
      this.count(row)
    },
    rateChange(row) {
      this.count(row)
    },
    disChange(row) {
      this.count(row)
    },
    count(row) {
      let price = row.Price?Number(row.Price):0
      let dis = row.Discount>0 ? Number(row.Discount) : 100;
      let qua = row.Quantity?Number(row.Quantity):0
      let rate = row.TaxRate?Number(row.TaxRate):0
      let ref = row.ReferenceCost?Number(row.ReferenceCost):0
      if(row.T !== 0) {
        row.T = 1
      }
      if(this.disposeTax==1){
        row.Price = (row.Offer * (1+rate / 100)).toFixed(2)
        row.Price=row.Price.toFixed(2)
      }else{
        row.Price = row.Offer.toFixed(2) 
      }
      row.Amount = (row.Price * qua - (dis/100)).toFixed(2)
      row.TaxAmount = (qua*(row.Offer * (rate / 100))).toFixed(2) || 0
      row.GrossProfit = (row.Amount - (qua * ref)).toFixed(2)
      this.subTable()
    },
    subTable() {
      this.$emit("getList",this.tableData.concat(this.tableDel))
    },
  },
};
</script>

<style>
.el-link{
  font-size: 14px;
}
input::-webkit-outer-spin-button,

input::-webkit-inner-spin-button { -webkit-appearance: none; }

input[type="number"]{ -moz-appearance: textfield; }
.table_head{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>